// src/main.ts
import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import MainLayout from './components/MainLayout.vue';
import { createWebHistory, createRouter } from 'vue-router';
import Login from './components/Login.vue';
import AutoLogin from './components/AutoLogin.vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'font-awesome/css/font-awesome.css';
import { AuthService } from './services/auth-service';

// Import Vue Toastification and its CSS
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
// Keep toasts within the user's visible viewport when embedded in an iframe.
import './assets/toast-position.css';
import { initIframeToastPosition } from './composables/useIframeToastPosition';

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import { createGtm } from '@gtm-support/vue-gtm';

// Define your routes
const routes = [
  {
    path: '/',
    name: 'MainLayout',
    component: MainLayout,
    meta: { requiresAuth: true },
  },
  { path: '/login', name: 'Login', component: Login },
  { path: '/autoLogin', name: 'AutoLogin', component: AutoLogin }, //Cookie validation for auto-login
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  document.title = 'Dynamic Pricing';

  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !AuthService.isAuthenticated()
  ) {
    next({ name: 'AutoLogin' });
  } else {
    next();
  }
});

const app = createApp(App);

// Use the store
app.use(store);

// Use Vue Toastification with desired options
app.use(Toast, {
  position: POSITION.BOTTOM_CENTER,
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
});

app.use(FloatingVue);

app.use(router);

const gtmId = process.env.VUE_APP_GTM_ID;
if (gtmId) {
  app.use(
    createGtm({
      id: gtmId,
      vueRouter: router,
    })
  );
}

app.mount('#app');

initIframeToastPosition();

export { router };
